/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
import React, { useRef, useState, useEffect } from 'react';
import { Box, makeStyles, Typography, Grid, Button, Tooltip } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import Recaptcha from 'react-invisible-recaptcha';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { commonSelector } from 'redux/custom-selector';
import { setUserInfo } from 'redux/actions/user-action';
import InputField from '../../custom-components/form-fields/inputField';
import { LOGIN_AUTH_METHOD, SSO_AUTH, NEW_LOGIN } from '../../api-setup/api-endpoints.js';
import validateFunctions from '../../models/validation';
import { LoginEmailSchema, LoginSchema } from '../../models/schema';
import userSetting from '../../settings';
import BtnWithLoader from 'custom-components/btnWithLoader';
import { setUserCredential, setOnboardingDataCollectionDone } from 'lib/cookies.js';
import { API } from 'api-setup/api-helper';
import mixPanel from 'lib/mix-panel';
import amplitude from 'lib/amplitude';
import usePosthogClient from 'lib/posthog/usePosthogClient';
import { downTimeModalAction } from 'pages/DownTime/downTimeReducer';
import { genericAPICall } from '../../api-setup/api-helper.js';
import { setNewMessage } from 'redux/actions/setting-actions';
import VSvgLockIcon from '../../icons/VSvgLockIcon';
import VSvgMailIcon from '../../icons/VSvgMailIcon';
import { NotePencilIcon } from '@phosphor-icons/react';
import useAuthStyles from './styles';
import usePlatform from 'lib/hooks/usePlatform';

const useStyles = makeStyles((theme) => ({
  anchorLink: {
    textDecoration: 'none',
  },
  fieldIcon: {
    color: `${theme.palette.text.primary} !important`,
  },
  editIcon: {
    color: `${theme.palette.text.primary} !important`,
    borderRadius: 0,
    cursor: 'pointer'
  },
}));

// Check for validation of form when login button clicked
function handleValidations(formFields) {
  const { email, password, isAcceptTerms } = formFields;
  const data = {
    email: email.trim(),
    password: password.trim(),
    isAcceptTerms: Boolean(isAcceptTerms),
  };
  const errorObj = validateFunctions.validate(LoginSchema, data);
  if (errorObj || !isAcceptTerms) {
    if (!isAcceptTerms) {
      return {
        ...errorObj,
        isAcceptTerms: 'Agreeing to the terms of service and privacy policy is required',
      };
    }
    return errorObj;
  } else {
    return false;
  }
}

function handleValidationsEmail(data) {
  const { isAcceptTerms } = data;
  const errorObj = validateFunctions.validate(LoginEmailSchema, data);
  if (errorObj || !isAcceptTerms) {
    if (!isAcceptTerms) {
      return {
        ...errorObj,
        isAcceptTerms: 'Agreeing to the terms of service and privacy policy is required',
      };
    }
    return errorObj;
  } else {
    return false;
  }
}

// login API call
const makeAPIcall = (data, recaptchaRef, history, cb, errorCb, dispatch) => {
  genericAPICall(NEW_LOGIN, 'POST', data)
    // POSTAPI(false, LOGIN, null, null, data)
    .then((res) => {
      if (res.data.status === API.apiSuccessStatus) {
        const { token, userData, team_member_id, isOnboardingDataCollectionDone, organiser_id, isFirstLogin } =
          res.data.data;
        if (isFirstLogin) {
          history.push({
            pathname: '/set-password',
            state: {
              organiser_id,
              token,
              email: userData?.email,
            },
          });
        } else {
          setOnboardingDataCollectionDone(
            isOnboardingDataCollectionDone,
            'isOnboardingDataCollectionDone'
          );
          dispatch(downTimeModalAction(true)); // DOWNTIME MODAL ACTION TRIGGER
          setUserCredential(
            {
              authToken: token,
              teamMemberId: team_member_id,
              organiser_id,
              userPermission: userData.userPermission,
            },
            'userData'
          );
          const resp = {
            userData,
            isFirstLogin,
            isOnboardingDataCollectionDone,
          };
          if (cb) cb(resp);
        }
      } else {
        errorCb(res.data.message || 'Some error occurred');
        API.errStatusHandler(res, history, dispatch, () => {
          if (process.env.REACT_APP_ENV_TYPE === 'stg' ||
            process.env.REACT_APP_ENV_TYPE === 'prod') {
            if (recaptchaRef && recaptchaRef.current) {
              recaptchaRef.current.reset();
            }
          }
        });
      }
    })
    .catch((err) => {
      const errorMsg =
        err.response && err.response.data ? err.response.data.message : 'Some error occurred';
      errorCb(errorMsg);
      API.catchHandler(err, () => {
        if (process.env.REACT_APP_ENV_TYPE === 'stg' ||
          process.env.REACT_APP_ENV_TYPE === 'prod') {
          if (recaptchaRef && recaptchaRef.current) {
            recaptchaRef.current.reset();
          }
        }
      });
    });
};

let isOnboardingDataCollectionDone = '0';

export default function LoginForm(props) {
  // ** States
  const [formFields, setFormFields] = useState({
    email: '',
    password: '',
    isAcceptTerms: true,
  });
  const [errorObj, setErrorObj] = useState({});
  const [captchaToken, setCaptchaToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPasswordField, setIsShowPasswordField] = useState(false);
  const [ssoDetails, setSsoDetails] = useState({});
  const [welName, setWelName] = useState('');
  const [readOnlyEmail, setReadOnlyEmail] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();
  const reduxData = useSelector(commonSelector, shallowEqual);
  const { identifyOrgData } = usePosthogClient();
  const { anchorLink, fieldIcon, editIcon } = useStyles();
  const recaptchaRef = useRef(null);
  const { isWebinarPlus } = usePlatform();
  const {
    authBtn,
    primaryBtn,
    secondaryBtn,
    authInputStyles,
    formContainer,
    formInputBox,
    pageContainer,
    titleBox,
    titleText,
  } = useAuthStyles({ isWebinarPlus });

  const isSubmitSSOEnabled = ssoDetails?.can_configure_dash_sso && ssoDetails?.is_dash_sso_enabled;

  const isCaptchaEnabled = process.env.REACT_APP_ENV_TYPE === 'stg' || process.env.REACT_APP_ENV_TYPE === 'prod';

  // ** Effects
  useEffect(() => {
    const { location } = props;
    if (location.state && location.state.name && location.state.email) {
      setFormFields({ ...formFields, email: location.state.email });
      setWelName(`Welcome Back! ${location.state.name}`);
      setReadOnlyEmail(true);
    } else {
      setWelName('');
      setReadOnlyEmail(false);
    }
    amplitude.Track.onPage('login');
  }, []);

  useEffect(() => {
    if (captchaToken) {
      setIsLoading(true);
      const data = {
        email: formFields.email.trim(),
        password: formFields.password.trim(),
        captchaToken,
      };
      makeAPIcall(
        { data },
        recaptchaRef,
        history,
        (resp) => {
          const userInfo = resp.userData;
          const isOnboardingColl = resp.isOnboardingDataCollectionDone;
          if (isOnboardingColl) {
            isOnboardingDataCollectionDone = isOnboardingColl;
          }
          mixPanel.Login.loginSuccessMP(
            userInfo.id,
            userInfo.email,
            userInfo.firstName,
            userInfo.lastName,
            'FORM'
          );
          const deviceIdAmplitude = decodeURIComponent(
            window.location.search.replace(
              new RegExp(
                `^(?:.*[&\\?]${encodeURIComponent('deviceId').replace(
                  // eslint-disable-next-line no-useless-escape
                  /[\.\+\*]/g,
                  '\\$&'
                )}(?:\\=([^&]*))?)?.*$`,
                'i'
              ),
              '$1'
            )
          );
          if (deviceIdAmplitude) {
            amplitude.Track.loginSuccessful(
              'email',
              userInfo.first_name,
              userInfo.last_name,
              userInfo.id,
              userInfo.organisation,
              deviceIdAmplitude
            );
          } else {
            amplitude.Track.loginSuccessful(
              'email',
              userInfo.first_name,
              userInfo.last_name,
              userInfo.id,
              userInfo.organisation
            );
          }
          console.log(':::reduxData.UserInfo login', userInfo)
          identifyOrgData(userInfo.email, {
            organiser_id: userInfo.organiser_id,
            ...(userInfo.organisation && { organisation: userInfo.organisation })
          });
          dispatch(setUserInfo(userInfo));
          setIsLoading(false);
        },
        () => {
          setIsLoading(false);
        },
        dispatch
      );
    }
  }, [captchaToken]);

  useEffect(() => {
    if (reduxData.userId) {
      if (isOnboardingDataCollectionDone.toString() === '1') {
        history.replace('/events'); // event page redirection if login API success
      } else {
        history.replace('/onboarding');
      }
    }
  }, [reduxData.userId]);


  // ** Handlers
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (errorObj[name]) setErrorObj({ ...errorObj, [name]: '' });
    setFormFields({ ...formFields, [name]: value });
  };

  const handleSSOLogin = (event) => {
    event.preventDefault();
    setIsLoading(true);
    genericAPICall(SSO_AUTH, 'GET', {}, {}, { usertoken: ssoDetails?.user_token }).then((response) => {
      if (response.data.status === 200 && response.data.data) {
        if (response.data.data && response.data.data?.auth_url) {
          window.open(response.data.data?.auth_url, '_self');
        }
      }
    })
  }

  const handleLogin = (event) => {
    // reset userid in amplitude
    amplitude.Track.resetUserID();
    event.preventDefault();

    if (Object.keys(ssoDetails).length <= 0) {
      const errorObject = handleValidationsEmail({
        email: formFields.email,
        isAcceptTerms: formFields.isAcceptTerms
      });
      if (!Object.keys(errorObject).length) {
        setIsLoading(true);
        genericAPICall(LOGIN_AUTH_METHOD, 'POST', { "data": { "email": formFields.email } }).then((response) => {
          if (response.data.status === 200 && response.data.data) {
            setReadOnlyEmail(true);
            if (response.data.data) {
              if (response.data.data?.can_configure_dash_sso && response.data.data?.is_dash_sso_enabled) {
                setIsShowPasswordField(response.data.data?.show_dash_sso_pwd_opt);
              } else {
                setIsShowPasswordField(true);
              }
            }

            setSsoDetails(response.data.data);
            setIsLoading(false);
          }
        }).catch((error) => {
          const message = error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong';
          dispatch(setNewMessage({ message, type: 'error', show: true }));
          setIsLoading(false);
        })
      } else {
        setErrorObj(errorObject);
      }
    } else {
      const errorObject = handleValidations(formFields);
      if (!errorObject) {
        amplitude.Track.enterEmail(); // TODO : @ramesh removed email
        setErrorObj({});
        if (isCaptchaEnabled) {
          if (recaptchaRef && recaptchaRef.current) {
            recaptchaRef.current.execute(); // ref
          }
        } else {
          setIsLoading(true);
          const data = {
            email: formFields.email.trim(),
            password: formFields.password.trim(),
            captchaToken,
          };
          makeAPIcall(
            { data },
            recaptchaRef,
            history,
            (resp) => {
              const userInfo = resp.userData;
              const isOnboardingColl = resp.isOnboardingDataCollectionDone;
              if (isOnboardingColl) {
                isOnboardingDataCollectionDone = isOnboardingColl;
              }
              mixPanel.Login.loginSuccessMP(
                userInfo.id,
                userInfo.email,
                userInfo.firstName,
                userInfo.lastName,
                'FORM'
              );
              amplitude.Track.loginSuccessful(
                'email',
                userInfo.first_name,
                userInfo.last_name,
                userInfo.id,
                userInfo.organisation
              );
              identifyOrgData(userInfo.email, {
                organiser_id: userInfo.organiser_id,
                ...(userInfo.organisation && { organisation: userInfo.organisation })
              });
              dispatch(setUserInfo(userInfo));
              setIsLoading(false);
            },
            () => {
              setIsLoading(false);
            },
            dispatch
          );
        }
      } else {
        setErrorObj(errorObject);
      }
    }
  };

  return (
    <Box className={pageContainer}>
      <Box className={titleBox}>
        <Typography variant='h2' className={titleText}>
          Login.
        </Typography>
      </Box>
      <Box component='form' className={formContainer}>
        <Box className={formInputBox}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <InputField
                disabled={isLoading}
                readOnly={readOnlyEmail}
                className={authInputStyles}
                required
                placeholder="Email address"
                type="email"
                id="email"
                name="email"
                startAdornment
                startIconAdornment
                endAdornment
                endIconAdornment
                startAdornmentIcon={<VSvgMailIcon className={fieldIcon} />}
                endAdornmentIcon={readOnlyEmail && <Tooltip title={`Different user? Click to edit email`} placement="top"><NotePencilIcon size={18} className={editIcon} onClick={() => {
                  setReadOnlyEmail(false);
                  setFormFields({ ...formFields, password: '', isAcceptTerms: true });
                  setSsoDetails({});
                  setIsShowPasswordField(false);
                  setErrorObj({});
                }} /></Tooltip>}
                error={errorObj.email}
                onChange={handleChange}
                value={formFields.email}
                autoComplete='email'
              />
            </Grid>
            {isShowPasswordField &&
              <Grid item xs={12}>
                <InputField
                  disabled={isLoading}
                  className={authInputStyles}
                  required
                  placeholder="Password"
                  type="password"
                  id="password"
                  name="password"
                  startAdornment
                  startIconAdornment
                  startAdornmentIcon={<VSvgLockIcon className={fieldIcon} />}
                  showFieldVisibilityBtn
                  error={errorObj.password}
                  onChange={handleChange}
                  value={formFields.password}
                  autoComplete='off'
                />
              </Grid>}

          </Grid>
          {isShowPasswordField &&
            <Box textAlign="right" mt={4}>
              <Link to="/forgot-password" className={anchorLink}>
                <Typography color="textPrimary" component="span" variant="body1">
                  Forgot Password?
                </Typography>
              </Link>
            </Box>
          }
        </Box>

        <Box>
          <BtnWithLoader
            variant="contained"
            className={`${authBtn} ${primaryBtn}`}
            color="primary"
            disabled={isLoading}
            type="submit"
            isLoading={isLoading}
            loadingLabel="Logging In"
            onClick={(event) => isSubmitSSOEnabled && !isShowPasswordField ? handleSSOLogin(event) : handleLogin(event)}
            label={isSubmitSSOEnabled && !isShowPasswordField ? "Continue with SSO (Single Sign-On)" : isShowPasswordField ? "Login" : "Continue"}
            fullWidth
          />
          {(isSubmitSSOEnabled && isShowPasswordField) &&
            <Button className={`${authBtn} ${secondaryBtn}`} variant='outlined' color='secondary' fullWidth onClick={handleSSOLogin}>
              Continue with SSO (Single Sign-On)
            </Button>
          }
        </Box>
      </Box>
      {isCaptchaEnabled ? (
        <Recaptcha
          ref={recaptchaRef}
          sitekey={userSetting.recaptchaSiteKey}
          onResolved={(propCaptchaToken) => {
            setCaptchaToken(propCaptchaToken);
          }}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
